import {
  FlightJourney,
  ReturnFlightJourney,
} from '@shared/v2/services/types/api/parsedResponse';

import { hasReturnFlightJourney } from '../dataLayer/eventDataHelpers/getEcommerceFlightItem';

export interface FlightOriginDestination {
  origin: string | null;
  destination: string | null;
}

export interface GetFlightOriginDestinationProps {
  flightOption: FlightJourney | ReturnFlightJourney;
  flightDirection?: 'Departing' | 'Returning';
}

export const getFlightOriginDestination = ({
  flightOption,
  flightDirection = 'Departing',
}: GetFlightOriginDestinationProps): FlightOriginDestination => {
  const hasReturnFlight = hasReturnFlightJourney(flightOption);

  if (hasReturnFlight) {
    const returnFlightOption = flightOption as ReturnFlightJourney;
    const outboundSegments = returnFlightOption.flightSegments.outbound;

    return {
      origin: outboundSegments[0].origin.name,
      destination:
        outboundSegments[outboundSegments.length - 1].destination.name,
    };
  }

  const flightJourney = flightOption as FlightJourney;
  const flightSegments = flightJourney.flightSegments;

  if (flightSegments.length === 0) {
    return {
      origin: null,
      destination: null,
    };
  }

  const originSegment = flightSegments[0];
  const destinationSegment = flightSegments[flightSegments.length - 1];

  return {
    origin:
      flightDirection === 'Departing'
        ? originSegment.origin.name
        : originSegment.destination.name,
    destination:
      flightDirection === 'Departing'
        ? destinationSegment.destination.name
        : destinationSegment.origin.name,
  };
};
